/* eslint-disable no-unused-vars */
import React from 'react';
import { COLORS } from 'constants/colorPicker';
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemText } from '@mui/material';

const ListItemFolder = ({ folder, handleDelete }) => (
  <ListItem
    secondaryAction={
      <IconButton edge="end" aria-label="delete" onClick={handleDelete}>
        <img src="/images/chat/trash-icon.svg" alt="" style={{ width: 20, height: 20 }} />
      </IconButton>
    }
  >
    <ListItemAvatar>
      <Avatar width={48} height={48} style={{ background: folder.color }}>
        {COLORS.find((item) => item.color === folder.color)?.isDark ? (
          <img src="/images/chat/folder-icon-white.svg" alt="" style={{ width: 21, height: 15 }} />
        ) : (
          <img src="/images/chat/folder-icon.svg" alt="" style={{ width: 21, height: 15 }} />
        )}
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={folder.name} />
  </ListItem>
);

export default ListItemFolder;
